import { render, staticRenderFns } from "./newSeven.vue?vue&type=template&id=5a73f682&scoped=true&"
import script from "./newSeven.vue?vue&type=script&lang=js&"
export * from "./newSeven.vue?vue&type=script&lang=js&"
import style0 from "./newSeven.vue?vue&type=style&index=0&id=5a73f682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73f682",
  null
  
)

export default component.exports